import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styles: [],
    standalone: false
})
export class FooterComponent implements OnInit {
  ngOnInit(): void {}
}
